import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { AccordionState } from './accordion-interfaces';

@injectable()
export class AccordionStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<AccordionState> {

  key = { id: 31, name: { ns: 'interaction-suspend-data', name: 'accordion' }, format: 'protobuf' }

  serialize(data: AccordionState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new AccordionStateProtoMessage({
      states: data.states,
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<AccordionStateProtoMessage>(message, AccordionStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<AccordionState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<AccordionStateProtoMessage>(content, AccordionStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: AccordionState = {
      states: message.states,
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('AccordionStateProtoMessage')
class AccordionStateProtoMessage extends Message<AccordionStateProtoMessage> {
  @Field.d(1, 'bool', 'repeated')
  states: boolean[];

  @Field.d(2, 'bool', 'repeated')
  touched: boolean[];
}
